import { Logo } from "../../common/Logo";

function InfoFooter() {
  return (
    <div className="md:order-1">
      <Logo size="lg" />

      <p className="mt-5 max-w-sm text-sm leading-8 text-white/60">
        سامانه رسمی هیئت فوتبال شهرستان پاوه — مدیریت باشگاه‌ها، مسابقات،
        بازیکنان و رویدادها در یک پلتفرم یکپارچه.
      </p>
    </div>
  );
}

export default InfoFooter;
